import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container,
  Row,
  Col,
  ListGroup,
  Image,
  Form,
  Button,
  Card,
} from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import Message from '../components/Message';
import { addToCart, removeFromCart } from '../slices/cartSlice';
//import { addToCart, removeFromCart, clearCartItems } from '../slices/cartSlice'; // import clearCartItems

const PanierScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const successMessage = location.state?.success;




  // NOTE: no need for an async function here as we are not awaiting the
  // resolution of a Promise
  const addToCartHandler = (book, qty) => {
  console.log("Ajout au panier:", book, qty);
    dispatch(addToCart({ ...book, qty }));
  };

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  const checkoutHandler = () => {
    navigate('/shipping');
  };

// bouton vider panier 
// //!\ à supprimer/!\ 
  // const clearCartHandler = () => {
  //   if (window.confirm('Vider complètement le panier ?')) {
  //     dispatch(clearCartItems());
  //   }
  // };



  const totalItems = cartItems.reduce((acc, item) => acc + item.qty, 0);
  const totalItemsDisplay = totalItems > 1 ? (totalItems + " livres") : (totalItems + " livre"); 
  const totalPrice = cartItems.reduce((acc, item) => acc + item.qty * item.price, 0).toFixed(2);


  return (
    <Container>
        {successMessage ? (
          <Message variant="success">{successMessage}</Message>
        ) : (
              <div className="h1-container">
                <h1>Mon panier ({totalItemsDisplay})</h1>
              </div>
        )}

{/* 
      //  à supprimer/!\  bouton debug pour vider le panier 
      <Button 
        variant="danger" 
        className="mb-3" 
        onClick={clearCartHandler}
        disabled={cartItems.length === 0}
      >
        Vider le panier (force)
      </Button> */}

        {cartItems.length === 0 ? (
          <Message>
            Votre panier est vide
          </Message>
        ) : (
          <>
            {cartItems.map((item) => (
              <div key={item._id}>
                <Row>
                  <Col md={2}>
                    <Image src={item.cover} alt={item.title} fluid rounded className="bookProfile-img" />
                  </Col>
                  <Col md={4}>
                    <h1><Link to={`/livre/${item.slug}`}>{item?.title}</Link></h1>
                              <div className="subtitle">{item?.subtitle}</div>
                              <div className="ligneAuteurs">
                                <Link to={`/auteur/${item?.author1?.slug}`}>{item?.author1?.firstName && (item?.author1?.firstName)} {item?.author1?.lastName}</Link>
                                {item?.author2 && (
                                  <>
                                    , <Link to={`/auteur/${item?.author2?.slug}`}>
                                        {item?.author2?.firstName ? item?.author2?.firstName + ' ' : ''}
                                        {item?.author2?.lastName || ''}
                                    </Link>
                                  </>
                                )}
                    
                              </div> 
                  </Col>
                  <Col md={2}>{item.price} €</Col>
                  <Col md={2}>
                    <Form.Control
                      //as='select'
                      type='number'
                      value={item.qty}
                      min={1}
                      onChange={(e) =>
                        addToCartHandler(item, Number(e.target.value))
                      }
                    >
                      {/* {[...Array(item.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))} */}
                    </Form.Control>
                  </Col>
                  <Col md={2}>
                    <Button
                      type='button'
                      variant='light'
                      onClick={() => removeFromCartHandler(item._id)}
                    >
                      <FaTrash />
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
          </>
        )}
      <Col md={4}>
        <Card>
          <ListGroup variant='flush'>
            <ListGroup.Item>
              <h2>
                Total ({totalItemsDisplay})
              </h2>
              {totalPrice} €
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                type='button'
                className='btn-block'
                disabled={cartItems.length === 0}
                onClick={checkoutHandler}
              >
                Valider la commande
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Container>
  );
};

export default PanierScreen;
